import styled from 'styled-components';
import Colors from 'library/constants/colors';
import {
  TransitionConfig,
  ShadowSlight,
  ShadowElevation,
  ShadowHarsh,
} from '../constants/styles-config';
import { ButtonMid } from './text';

const IconBase = styled.i`
  display: inline-block;
  font-size: ${({ size = 28 }) => size}px;
  line-height: 32px;
  vertical-align: sub;
  margin-top: -1px;
  transition: color ${TransitionConfig};
`;

const ActionIconStyles = `
  display: inline-block;
  text-align: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color ${TransitionConfig}, box-shadow ${TransitionConfig};
  
  ${(props) => {
    if (props.actionType === 'trash') {
      return `
        color: ${Colors.error};
        
        span {
          color: inherit;
        }
      `;
    }
    return '';
  }}
`;

const ActionIconContainer = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.violet};
`;

const ActionIconListItem = styled.li`
  ${ActionIconStyles};
  width: 40px;
  height: 40px;
  margin: 0 4px;
  line-height: 40px;
  border-radius: 40px;
  background-color: ${({ disabled }) => (disabled ? Colors.shade09 : Colors.shade07)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  color: ${Colors.violet};
  cursor: pointer;

  ${(props) => {
    if (props.actionType === 'trash') {
      return `
        color: ${Colors.error};
        
        span, i {
          color: inherit;
        }`;
    }
    return '';
  }}
  
  &:hover {
    background-color: ${(props) => props.theme.colors.shade08};
    box-shadow: ${ShadowSlight};
  }
`;

export const ActionIconListItemBig = styled(ActionIconListItem)`
  width: 48px;
  height: 48px;
  line-height: 48px;
  border-radius: 48px;
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: ${Colors.shade08};
  box-shadow: ${ShadowSlight};
  color: ${Colors.violet};
  
  &:hover {
    background-color: ${Colors.shade07};
    box-shadow: ${ShadowHarsh};
  }
  
  ${IconBase} {
    width: 48px;
    font-size: 32px;
    vertical-align: -6px;
  }

  ${(props) => {
    if (props.actionType === 'trash') {
      return `
        color: ${Colors.error};
        
        span, i {
          color: inherit!important;
        }`;
    }
    return '';
  }}
`;

export const ActionIconListItemBigHorizontal = styled(ActionIconListItemBig)`
  position: relative;
  
  &:hover {
    padding-left: 18px;
    background-color: ${Colors.shade08};
    width: auto;
    
    &:before {
      opacity: 1;
    }
    
    ${IconBase} {
      margin-left: -3px;
    }

    span {
      font-size: inherit;
      opacity: 1;
    }
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: ${ShadowHarsh};
    opacity: 0;
    border-radius: 48px;
    transition: opacity ${TransitionConfig};
  }

  span {
    ${ButtonMid};
    font-size: 0;
    opacity: 0;
    color: ${Colors.shade02};
    transition: opacity ${TransitionConfig};
  }
`;

const IconSettings = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
`;

const IconLogout = styled.i`
  font-size: 32px;
  color: ${Colors.error};
  margin-bottom: 3px;
  margin-left: 15px;
`;

const IconPencil = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
  position: absolute;
  top: 42px;
  left: 45px;
`;

const IconModal = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SlickArrowStyles = `
  position: absolute;
  top: 54px;
  bottom: 0;
  z-index: 12;
  margin: auto;
  width: 52px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  color: ${Colors.violet};
  text-align: center;
  background-color: ${Colors.shade08};
  box-shadow: ${ShadowElevation};
  transition: background-color ${TransitionConfig};
  
  i {
    line-height: inherit;
  }

  &:before {
    content: none;
  }

  &:hover {
    background-color: ${Colors.shade06};
  }

  &.slick-disabled {
    pointer-events: none;
    color: ${Colors.shade05};
  }
  
  &.slick-next {
    right: 0;
    border-radius: 40px 0 0 40px;
    padding-left: 5px;
  }

  &.slick-prev {
    left: 0;
    border-radius: 0 40px 40px 0;
    padding-right: 5px;
  }
`;

export {
  ActionIconContainer,
  IconBase,
  ActionIconListItem,
  ActionIconStyles,
  IconSettings,
  IconLogout,
  IconModal,
  IconPencil,
};
